import React, { useContext } from 'react';
import LocalStorage from '../Services/Persistence/LocalStorage';
import ThemeStore from '../Stores/ThemeStore';
import { useStoreUpdate, useStoreValue } from '@cb/solaris-react/Utility/Store';
export const ThemeStoreContext = React.createContext(new ThemeStore(new LocalStorage()));
export default function useThemeStore() {
    const themeStore = useContext(ThemeStoreContext);
    return themeStore;
}
export function useTheme() {
    const themeStore = useThemeStore();
    const isThemeLoading = useStoreValue(themeStore, 'isLoading');
    const themeType = useStoreValue(themeStore, 'type');
    const setThemeType = useStoreUpdate(themeStore, 'type');
    const theme = themeStore.theme;
    return { theme, themeType, setThemeType, isThemeLoading };
}
//# sourceMappingURL=UseThemeStore.js.map